import {Component, OnDestroy} from "@angular/core";
import {GO_COMPONENTS} from "../../../enums/e-game-objects";
import {GoBaseComponent} from "../go-base.component";
import {UI_TEXTS} from "../../../enums/e-texts";
import {FactoryService} from "../../../services/factory.service";
import {JP} from "../../../helpers/jp";


@Component({
  selector: "go-floating-cost",
  templateUrl: "./go-floating-cost.component.html"
})
export class GoFloatingCostComponent extends GoBaseComponent implements OnDestroy {
  UI_TEXTS = UI_TEXTS;
  private _selected: any;

  get selected() { return this._selected; }
  get changes() { return JP.get(this.component, "/changes"); }


  constructor(private factoryService: FactoryService) {
    super(GO_COMPONENTS.FLOATING_COST);
  }


  onComponentRemoved() {
    this.onItemSelected(null);
  }


  onItemSelected(item: any) {
    this._selected = item;
  }


  onAddClick() {
    this.factoryService.gameObjectUtils.addEntryToFloatingCostChanges(this.component.changes);
  }


  ngOnDestroy(): void {
    this.onItemSelected(null);
  }
}



// WEBPACK FOOTER //
// /opt/app/develop/src/app/components/go/go-floating-cost/go-floating-cost.component.ts